import * as React from 'react';
const SvgBooth = (props) => (
  <svg viewBox="0 0 124 124" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M122 2H2v120h120V2Z"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29.096 100.71H23.29V23.29h77.419v77.42h-5.806"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="m2 2 21.29 21.29M122 2l-21.29 21.29M122 122l-21.29-21.29M2 122l21.29-21.29"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M78 40.903H46v69h32v-69ZM36 109.903h52"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgBooth;
